import TemplatesSettings from '@/pages/settings/templates'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(protected)/workspaces/$workspaceId/settings/templates')({
  component: TemplatesSettings,
})

